<script setup lang="ts">
import { useTranslation } from 'i18next-vue'
import type { InterestTag } from '@/type/Appointment'

interface Props {
  show: boolean
  selectedInterestTags: Record<number, boolean>
  interestTags: InterestTag[]
  loading: boolean
}

interface Emits {
  (e: 'selectTag', value: number): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const { t } = useTranslation()

// Handle tag selection
const handleSelectTag = (tagId: number) => {
  emit('selectTag', tagId)
}
</script>

<template>
  <van-cell-group v-if="show" class="group-container" inset>
    <p class="title">
      {{ t('appointmentrequest.interest_procedure') }}
      <span style="font-weight: normal; font-size: small; color: gray">
        {{ t('multi_select_hint') }}
      </span>
    </p>

    <van-loading v-if="loading" class="loading-container" size="24px"> {{ t('loading') }} </van-loading>

    <div v-else class="tags-container">
      <van-button
        v-for="tag in interestTags"
        :key="tag.id"
        v-bind="{
          type: selectedInterestTags[tag.id] ? 'primary' : 'default',
          color: selectedInterestTags[tag.id] ? 'primary' : '',
          size: 'small',
        }"
        @click.prevent="handleSelectTag(tag.id)"
      >
        {{ tag.name }}
      </van-button>
    </div>
  </van-cell-group>
</template>

<style scoped>
.group-container {
  margin: 15px 0px;
  border: 2px solid #c8c9cc;
  border-radius: 20px;
}

.title {
  font-weight: bold;
  padding: 10px 15px;
  font-size: 18px;
  margin: 0;
  color: #323233;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 15px 15px;
}

.tag-button:active {
  transform: scale(0.9);
}
</style>
